function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import ProjectsService from '@/apps/data-platform/services/master_data/projects_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import tasks from '@/js/tasks';
export default {
  name: 'DatasourceDsTabConexions',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          kdomain: null,
          ksubdomain: null,
          kbusiness_term: null
        };
      }
    }
  },
  data: function data() {
    return {
      projectListDict: [],
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      inputUploadFile: null,
      domain_table: '',
      files: [],
      currentFile: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      kdomain: null,
      ksubdomain: null,
      kbusiness_term: null,
      datasource_add: {
        project_name: null,
        name: '',
        description: ''
      },
      inputUploadImage: null,
      key_table: 1,
      dsources: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'selectBusinessTerm'])), {}, {
    headersDs: function headersDs() {
      var headers = [{
        value: 'project_name',
        text: this.$t('my_tasks.modals.project')
      }, {
        value: 'name',
        text: this.$t('my_tasks.tablas_tasks.name')
      }, {
        value: 'description',
        text: this.$t('my_tasks.modals.description')
      }];
      if (!this.readonly) {
        headers.push({
          value: 'action',
          text: this.$t('my_tasks.tablas_tasks.actions'),
          align: 'center'
        });
      }
      return headers;
    }
  }),
  created: function created() {
    this.getProjects();
    this.domain_table = window.userInfo && window.userInfo.domain ? window.userInfo.domain : '';
    this.environ_initial = this.item && this.item.environment ? this.item.environment : '';
    this.files = this.item && this.item.files ? this.item.files : [];
    // Sincroniza datasources iniciales
    this.dsources = this.item && Array.isArray(this.item.datasources) ? this.item.datasources.slice() : [];
  },
  methods: {
    getProjects: function getProjects() {
      var _this = this;
      ProjectsService.getAllProjects().then(function (response) {
        if (response && response.code === 200 && response.success) {
          var projectsByDomain = response.data && response.data.projects ? response.data.projects : {};
          var currentDomain = window.userInfo && window.userInfo.domain ? window.userInfo.domain : '';
          var projects = projectsByDomain[currentDomain] || [];
          _this.projectListDict = projects.map(function (x) {
            return {
              value: x,
              text: x
            };
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    validAddDatasource: function validAddDatasource() {
      if (!this.datasource_add.project_name) {
        tasks.toast.error('Select the project!');
        return false;
      }
      if (!this.datasource_add.name || this.datasource_add.name.trim().length === 0) {
        tasks.toast.error('Enter the name!');
        return false;
      }
      if (!this.datasource_add.description || this.datasource_add.description.trim().length === 0) {
        tasks.toast.error('Enter the description!');
        return false;
      }
      return true;
    },
    onAddDatasource: function onAddDatasource() {
      if (!this.validAddDatasource()) return;
      var ds = {
        project_name: this.datasource_add.project_name,
        name: (this.datasource_add.name || '').trim(),
        description: (this.datasource_add.description || '').trim()
      };
      // evita duplicados por (project_name + name)
      var exists = this.dsources.some(function (x) {
        return x.project_name === ds.project_name && (x.name || '').toLowerCase() === ds.name.toLowerCase();
      });
      if (exists) {
        tasks.toast.error('The datasource already exists in this project!');
        return;
      }
      this.dsources.push(ds);
      // sincroniza con el padre
      this.item.datasources = this.dsources.slice();
      this.$emit('onChangeDatasource', this.item.datasources);
      this.limpiarAdd();
      this.key_table += 1;
    },
    limpiarAdd: function limpiarAdd() {
      this.datasource_add = {
        project_name: null,
        name: '',
        description: ''
      };
    },
    onRemoveDatasource: function onRemoveDatasource(item) {
      var idx = this.dsources.indexOf(item);
      if (idx !== -1) {
        this.dsources.splice(idx, 1);
        this.item.datasources = this.dsources.slice();
        this.$emit('onChangeDatasource', this.item.datasources);
        this.key_table += 1;
      }
    }
  }
};